// extracted by mini-css-extract-plugin
export var boxItems = "_b8-1";
export var boxItemsLg = "_b8-2";
export var button = "_b8-7";
export var buttonHoverless = "_b8-9";
export var buttonLg = "_b8-8";
export var filterGroupBox = "_b8-0";
export var icon = "_b8-3";
export var iconSecondary = "_b8-6";
export var iconWrapper = "_b8-4";
export var iconWrapperLg = "_b8-5";
export var truncatedLabel = "_b8-a";